export default {
  home: state => { return state.home },
  contactInfo: state => { return state.contactInfo },
  url: state => action => {
    let url = state.server
    url += action
    return url
  },
}